<template>
  <div class="topLink">
    <ul>
      <li v-for="(list,index) in linkList" :data-index="index" :key="index">
        <a :href="list.link" target="_blank">{{list.name}}</a>
        <span class="divider" v-if="(index+1) != linkList.length">|</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {
      linkList: [
        { name: "人大附中", link: "http://www.rdfz.cn/" },
        { name: "清华附中", link: "http://www.qhfz.edu.cn/" },
        { name: "华师大一附中", link: "http://www.sdfz.sh.cn/" },
        // { name: "家校互联", link: "http://home.xinkaoyun.com/" },
        // { name: "假期作业", link: "http://hz.xinkaoyun.com:8099/" },
        // { name: "衡中校友之家", link: "http://hbhzxy.wiiyun.com" },
        { name: "河北衡水中学", link: "http://www.hbhszx.cn" },
        // { name: "衡水一中", link: "http://www.hengshuidiyizhongxue.com/" },
        { name: "衡水中学实验学校", link: "http://www.hszxsyxx.com/" },
        // { name: "衡水一中国际交流中心", link: "http://www.hsyzgjjlzx.com/" },
        // { name: "图书馆", link: "http://tsg.hbhz.net/" },
        // {
        //   name: "信金焕名师工作室",
        //   link:
        //     "http://mingshi.hbte.com.cn:5060/index.php/Home/Zindex/zindex/id/100.html"
        // },
        // { name: "鑫考云校园", link: "http://hz.xinkaoyun.com/" },
        // {
        //   name: "电信校园卡办理平台",
        //   link: "http://www.edu2live.com/hzzxdj/index.html"
        // },
        // { name: "联通201卡", link: "http://www.hscard.com.cn/" }
      ]
    };
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/com/topLink.vue